export const ADMIN_API_MAILING_URL = '/admin/mailing/';

export const ADMIN_API_MAILING_PAGE = 'admin-mailing';
export const ADMIN_API_MAILING_EDIT_PAGE = 'admin-mailing-edit';
export const ADMIN_API_MAILING_LIST_KEY = 'admin_mailing_list';
export const ADMIN_API_MAILING_BY_ID_KEY = 'admin_mailing_by_id';
export const ADMIN_API_MAILING_STATS_KEY = 'admin_mailing_stats';

export const MAILING_ON_PAGE = 20;

export const getMailingStatsUrl = (internalId: string) =>
  `${ADMIN_API_MAILING_URL}${internalId}/stats/`;
